export type LegalDocumentKey = "terms" | "privacy" | "avv" | "userTerms";

export type LegalDocument = {
  key: LegalDocumentKey;
  title: string;
  url: string;
  version: string;
};

export const LEGAL_DOCUMENTS = {
  terms: {
    key: "terms",
    title: "AGB",
    url: "/legal/agb",
    version: "2026-06-24",
  },
  privacy: {
    key: "privacy",
    title: "Datenschutzhinweise",
    url: "/datenschutz",
    version: "2026-06-24",
  },
  avv: {
    key: "avv",
    title: "Auftragsverarbeitungsvertrag",
    url: "/legal/avv",
    version: "2026-06-24",
  },
  userTerms: {
    key: "userTerms",
    title: "Nutzungsbedingungen",
    url: "/legal/nutzungsbedingungen",
    version: "2026-06-24",
  },
} as const satisfies Record<LegalDocumentKey, LegalDocument>;
